module.exports = __webpack_public_path__ + "img/cn_manifest.8fa9d8a3.svg";